import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_ROW_ACCORDION_CONFIG } from './cms-component-row-accordion.config';
import { NCmsComponentRowAccordion } from './cms-component-row-accordion.interface';

let uid = 0;

@Component({
    selector: 'cms-component-row-accordion',
    templateUrl: './cms-component-row-accordion.component.html',
    standalone: true,
    imports: [CommonModule, HideUpComponent, ICmsClientModule, ToggleModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentRowAccordionComponent>(CMS_COMPONENT_ROW_ACCORDION_CONFIG)
export class CmsComponentRowAccordionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentRowAccordion.IData;

    private readonly _uid = `rowAccordion${uid++}`;

    get isAccordion(): boolean {
        return this.client.sizeId <= this.component.accordionBreakdown;
    }

    get uid(): string {
        return this._uid;
    }
}
